import CustomPost from "../CustomPost/CustomPost";
import { useEffect, useState } from "react";
import axios from "axios";
import "./location.css";
import { useGlobalContext } from "../../../Context/Context";

const Location = ({ setCheckBack, checkBack, selectedCompany, currentTab }) => {
  const [location, setLocation] = useState({
    nameComponent: "location",
    data: [],
    name: "Mesta",
    titleChange: "mesto",
    titles: ["Naziv", "Adresa", "Grad"],
    properties: {
      name: "",
      address: "",
      town: "",
    },
  });

  const { baseUrl } = useGlobalContext();
  const { loggedUser, apiKey } = useGlobalContext();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(
          `${baseUrl}/admin_panel/company_places/readByCompanyId.php`,
          {
            company_id: selectedCompany.company_id,
            user_id: loggedUser.id,
            api_key: apiKey,
          }
        );
        const { data } = response;

        if (data.status === 200) {
          const newData = data.data.map((item) => {
            return {
              name: item.company_place_name,
              address: item.company_place_address,
              town: item.company_place_city,
              id: parseInt(item.company_place_id),
            };
          });
          setLocation({ ...location, data: newData });
        }
      } catch (error) {
        if (error.response.status === 404) {
          // not found
          console.log("Nema nijedna lokacija");
          setLocation({ ...location, data: [] });
        }
      }
    };
    fetchData();
  }, []);

  return (
    <div className="left-side-location">
      <CustomPost
        setCheckBack={setCheckBack}
        checkBack={checkBack}
        custom={location}
        setCustom={setLocation}
        selectedCompany={selectedCompany}
        currentTab={currentTab}
      />
    </div>
  );
};

export default Location;
